export default __webpack_public_path__ + "static/media/vehicle_active_driver.a4f34d1c.svg";